const MIN_CHARACTERS = 8

export const validatePassword = (password) => {
    if(!password || password.length < MIN_CHARACTERS) return false
    if(/^\d+$/.test(password)) return false

    return true
}